import { MyAxios, handleError, handleResponse } from '@services/SettingAxios';
import { fetchFeedBackLkDto } from './api.dto';

export const fetchFeedBackLk = async (query: fetchFeedBackLkDto) => {
  return await MyAxios.post('/api/feedback', query).then(handleResponse).catch(handleError);
};
